"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VNSnackbarSystem = void 0;
var _react = _interopRequireDefault(require("react"));
var _VNSnackbar = require("../components/VNSnackbar");
var _Selectors = require("../Selectors");
var _ActionCreators = require("../ActionCreators");
var VNSnackbarSystem = function VNSnackbarSystem() {
  var snackbarData = (0, _Selectors.getSnackbarSystemData)();
  return /*#__PURE__*/_react.default.createElement(_VNSnackbar.VNSnackbar, {
    cssProps: snackbarData.has("cssProps") ? snackbarData.get("cssProps") : null,
    autoHideDuration: snackbarData.get("autoHideDuration") !== undefined ? snackbarData.get("autoHideDuration") : undefined,
    alert: snackbarData.has("alert") ? snackbarData.get("alert") : null,
    action: snackbarData.get("action") ? snackbarData.get("action") : null,
    message: snackbarData.get("message"),
    open: snackbarData.has("open") ? snackbarData.get("open") : false,
    onHandleClose: function onHandleClose() {
      (0, _ActionCreators.resetSnackbarSystemData)();
    }
  });
};
exports.VNSnackbarSystem = VNSnackbarSystem;